import * as React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { BusinessReportOutcomeDetails } from "./businessReports.types";
import { BusinessReportsOutcomeListRow } from "./outcomeListRow";
import { useGetBusinessReportsOutcomeQuery } from "./businessReports.api";
import { Pagination } from "@/views/drive/pagination";

const emptyList: BusinessReportOutcomeDetails[] = [];

interface Props {
  tableRef: React.RefObject<HTMLDivElement>;
}

export const BusinessReportsOutcomeList: React.FC<Props> = ({ tableRef }) => {
  const [page, setPage] = React.useState(1);

  const { data } = useGetBusinessReportsOutcomeQuery({ offset: page - 1 });

  if (!data) {
    return null;
  }

  const { results: businessReportOutcome = emptyList, total = 0 } = data;

  return (
    <>
      <h3 className="mb-5 text-2xl font-semibold">Recent Snapshots</h3>
      <div className="w-full">
        <div className="relative overflow-hidden rounded-xl border bg-white shadow-sm">
          <div ref={tableRef} className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="rounded-t-xl">
                  <TableHead className="w-[180px] bg-gray-50/80 py-3 pl-6">Created</TableHead>
                  <TableHead className="min-w-[300px] bg-gray-50/80 py-3">Details</TableHead>
                  <TableHead className="hidden min-w-[280px] bg-gray-50/80 py-3 lg:table-cell">Owner</TableHead>
                  <TableHead className="w-[100px] bg-gray-50/80 py-3 pr-6 text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {businessReportOutcome.length ? (
                  businessReportOutcome.map(item => (
                    <BusinessReportsOutcomeListRow key={item.id} businessReportOutcome={item} />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} className="h-24 text-center text-muted-foreground">
                      No snapshots found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
        <Pagination currentPage={page} totalPages={Math.ceil(total / 10)} onPageChange={setPage} />
      </div>
    </>
  );
};
